export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8184.4a955945.jpg";